var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "2.0 2.0 20.0 20.0",
    width: 20,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,4h-5v3h2v1h-2v2h2v1h-2v2h2v1h-2v2h2v1h-2v3h5c1.105,0,2-0.895,2-2V6C22,4.895,21.105,4,20,4z M20,17h-2v-1h2V17z M20,14h-2v-1h2V14z M20,11h-2v-1h2V11z M20,8h-2V7h2V8z",
    fill: "inherit"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4v16l12,2V2L2,4z M8.983,16l-1.299-2.608c-0.049-0.092-0.107-0.277-0.155-0.534H7.51 c-0.029,0.123-0.087,0.308-0.175,0.555L6.026,16H4l2.404-4.005L4.204,8h2.075l1.076,2.393c0.087,0.195,0.155,0.421,0.223,0.678 h0.029c0.039-0.154,0.116-0.39,0.233-0.698L9.042,8h1.891l-2.259,3.964L11,16H8.983z",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.3f466f1e12c869b1f71efbb3d1f1772f.svg";
export { ForwardRef as ReactComponent };